import { Component, OnInit, Optional } from '@angular/core';
import { CustomTableComponent } from '../custom-table/custom-table.component';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { Subscription } from 'rxjs';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { CommonModule } from '@angular/common';
import { CustomButtonComponent } from '../custom-components/custom-button/custom-button.component';
import { ModalObjectType } from 'src/app/interfaces/modal-object-types.interface';

@Component({
  selector: 'app-custom-documents-review',
  templateUrl: './custom-documents-review.component.html',
  styleUrls: ['./custom-documents-review.component.scss'],
  standalone: true,
  imports: [CustomTableComponent, CommonModule, CustomButtonComponent]
})
export class CustomDocumentsReviewComponent implements OnInit {

  data: PagedResponseModel<any> = new PagedResponseModel<any>();
  headers: ColumnResponseModel[] = [];
  infoMessage: string = '';
  buttonLabel: string = '';
  subscription: Subscription;

  constructor(public config: DynamicDialogConfig,
    @Optional() private ref: DynamicDialogRef) { }

  ngOnInit() {
    const inputs$ = this.config.data?.inputs$;
    if (!inputs$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }
    this.subscription = inputs$.subscribe((inputs: any) => {
      this.headers = inputs.headers ?? [];
      this.data = inputs.data ?? new PagedResponseModel<any>();
      this.infoMessage = inputs.infoMessage ?? '';
      this.buttonLabel = inputs.buttonLabel ?? '';
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  close() {
    const data: ModalObjectType = {};
    data.params = { reload: true };
    this.ref.close(data);
  }

  onButtonEmit() {
    this.config.data?.output$?.next({ type: 'onButton' });
  }

  onExportEmit() {
    this.config.data?.output$?.next({ type: 'onExport' });
  }

  onPageChangeEmit(event: { page: number; pageSize: number; sortField: string | undefined; sortOrder: number }) {
    this.config.data?.output$?.next({ type: 'onPageChange', payload: event });
  }
}
